import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { IIceEntity } from 'projects/icemedx-lib/src/models/core/IceEntity';

import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { PatientService } from 'projects/icemedx-lib/src/services/patient/patient.service';

import {
  IcecontrolSettings,
  iceColumnDefinition,
} from 'projects/icemedx-lib/src/components/models/icesettings';

import { PhrBaseListView } from '../phrbaselistview.component';
import { provider_index } from '../../../../icemedx-lib/src/models/domain/provider_index';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { userTypes } from 'projects/icemedx-lib/src/login/login.config';
import { MessageService } from 'projects/icemedx-lib/src/services/message/message.service';
import { provider_reference } from '../../../../icemedx-lib/src/models/domain/provider_reference';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';

@Component({
  selector: 'app-phrproviders',
  templateUrl: './phrproviders.component.html',
  styleUrls: ['./phrproviders.component.scss'],
  providers: [AppService, IceNavService]
})
export class PhrprovidersComponent extends PhrBaseListView implements OnInit {
  constructor(appSvc: AppService, loginSvc: LoginService, messageSvc: MessageService, navSvc: IceNavService, ptSvc: PatientService, medCodeSvc: MedicalcodesService, router: Router) {
    super(appSvc, loginSvc, navSvc, ptSvc, router);

    this.nameOfView = "Care Team";
    appSvc.defaultMenus();
    appSvc.addBreadcrumb(this.nameOfView, {}, true, "");

    debugger;

    let feaAccess = this.getPermission(userTypes.USER_FEATURES.ufPatientProviderList).default_access;
    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      setTimeout(function () {
        messageSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
    } else {
      this.dataViewSettings = this.viewSetup([]);

      ptSvc.getCareTeam(appSvc.getCurrentAccountType() != IceTypes.ACCOUNT_TYPE.actPatient ? appSvc.getCurrentPatient() : appSvc.getCurrentAccount()).subscribe(
        data => {
          if (data != null) {
            let prorefs: provider_reference[] = [];
            let proidxs: provider_index[] = [];

            for (let i = 0; i < data.length; i++) {
              let proobj = data[i];
              if (Iceutility.isfunction(proobj.gettablename) == false) continue;

              if (proobj.gettablename() == "PROVIDER_REFERENCE")
                prorefs.push(proobj);
              else if (proobj.gettablename() == "PROVIDER_INDEX")
                proidxs.push(proobj);
            }

            for (let i = 0; i < proidxs.length; i++) {
              let pro = proidxs[i];
              if (pro == null) continue;

              if (pro.account_type == IceTypes.ACCOUNT_TYPE.actFacility
                || pro.account_type == IceTypes.ACCOUNT_TYPE.actPharmacy
                || pro.account_type == IceTypes.ACCOUNT_TYPE.actVendor) {
                pro["display_name"] = pro.organization_name;
                if (pro.first_name.length > 0) {
                  pro["display_name"] += " (" + pro.getdisplayname(false) + ")";
                }
              }
              else {
                pro["display_name"] = pro.getdisplayname(false);
              }

              pro["role"] = "";
              let fndRole = prorefs.filter(r => r.trans_account == pro.trans_account);
              if (fndRole.length > 0) {
                medCodeSvc.getCodes("PROVIDER_CODE", "", "", "").subscribe(
                  codeData => {
                    if (codeData == null) return;
                    let fndCode = codeData.filter(c => c.code == fndRole[0].provider_code);
                    if (fndCode.length > 0) {
                      if (pro["role"].length == 0)
                        pro["role"] += fndCode[0].title;
                      else
                        pro["role"] += " " + fndCode[0].title;
                    }
                  },
                  codeError => {
                    console.log(JSON.stringify(medCodeSvc.getLastErrors()));
                  });
              }

              medCodeSvc.getCodes("TAXONOMY", "", "", "").subscribe(
                codeData => {
                  if (codeData && codeData.length > 0 && codeData[0] != null) {
                    let codes: basecode[] = codeData;
                    let desc = pro.taxonomy_code;
                    let fndCode = codeData.filter(c => c.code == pro.taxonomy_code);
                    if (fndCode.length > 0) {
                      if (pro["role"].length == 0)
                        pro["role"] += fndCode[0].description;
                      else
                        pro["role"] += " " + fndCode[0].description;
                    }
                  }
                },
                codeError => {
                  console.log(JSON.stringify(medCodeSvc.getLastErrors()));
                });

              pro["address"] = pro.street1;
              if (pro.street2.length > 0)
                pro["address"] += " " + pro.street2;

              let local = pro.city;
              if (pro.state_id.length > 0)
                local += ", " + pro.state_id;

              if (pro.postal_code.length > 0)
                local += " " + pro.postal_code;

              if (local.length > 0)
                pro["address"] += " " + local;
            }
            this.refreshTableData(proidxs);
          }          
        },
        error => {
        });
    }
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    return [
      new iceColumnDefinition("display_name", "Provider(s)", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("role", "Role(s)", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("contact", "Contact", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("address", "Address", false, false,
        new IcecontrolSettings("icelabel", { width: "200px" }, null, null)),
      new iceColumnDefinition("trans_account", "trans_account", true),
    ];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }
}
